var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko with: props --> <div class="nfd-tree"><!-- ko if: treeData.isEmpty() --> <div class="nfd-tree-empty"data-bind="template: {nodes: emptyTemplate}"></div><!-- /ko --><!-- ko ifnot: treeData.isEmpty() --><!-- ko if: listOptions --> <div class="nfd-tree-list"> <nfd-tree-list params="{ props: listOptions }"></nfd-tree-list> </div><!-- /ko --><!-- /ko --> </div> <!-- /ko -->';
}
return __p;
};
